import styled from "styled-components";
import {
  PiArrowBendRightDown,
  PiArrowBendRightUp,
} from "react-icons/pi";

import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import * as pdfjsLib from "pdfjs-dist";

import questionMark from "../../images/svg/question.svg";

const Container = styled.div`
  width: 100%;
  min-width: 0;

  display: flex;
  flex-direction: column;

  border: 1px solid
    ${({ theme }) => theme.mainBorderColor};

  border-radius: 20px;

  position: relative;

  transition: background-color 0.2s ease;

  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  &:hover {
    background-color: ${({ theme }) =>
      theme.secondaryBgColor};
  }

  /*
   * Araç bilgileri
   */
  .wrapper {
    width: 100%;
    min-width: 0;

    display: grid;

    /*
     * İlk iki kolon bilgiler,
     * son kolon belge görüntüleme butonu.
     */
    grid-template-columns:
      minmax(0, 1fr)
      minmax(0, 1.3fr)
      minmax(180px, 0.7fr);

    gap: 25px;

    align-items: center;

    padding: 20px;
  }

  .column-item {
    min-width: 0;

    color: ${({ theme }) => theme.mainTextColor};

    display: flex;
    flex-direction: column;

    justify-content: center;

    gap: 10px;
  }

  .data-item {
    width: 100%;
    min-width: 0;

    font-size: 14px;

    display: flex;
    align-items: flex-start;

    gap: 5px;

    line-height: 1.4;
  }

  .data-item .key {
    font-weight: var(--font-weight-xl);

    flex-shrink: 0;
  }

  .data-item .value {
    font-weight: var(--font-weight-md);

    min-width: 0;

    word-break: break-word;
    overflow-wrap: anywhere;
  }

  /*
   * Belgeleri göster butonu
   */
  .show-doc-Btn {
    width: fit-content;

    border: none;
    outline: none;

    background: transparent;

    padding: 0;

    font-size: 14px;
    font-weight: var(--font-weight-lg);

    color: var(--color-main);

    display: flex;
    align-items: center;

    gap: 5px;

    text-decoration: underline;

    cursor: pointer;

    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.75;
    }

    .arr-icon {
      font-size: 1.2rem;
      flex-shrink: 0;
    }
  }

  /*
   * Belge alanı
   */
  .doc-container {
    width: 100%;
    min-width: 0;

    display: flex;
    flex-direction: column;

    align-items: center;

    margin-top: 5px;

    padding: 20px;
  }

  .doc-container-top {
    width: 100%;

    border-bottom: 1px solid var(--color-main);

    margin-bottom: 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    gap: 15px;
  }

  .doc-container-top-title {
    font-size: 18px;
    font-weight: 600;

    color: var(--color-main);

    padding-bottom: 5px;
  }

  .doc-container-top-hide-btn {
    flex-shrink: 0;

    border: none;
    outline: none;

    background: transparent;

    padding: 0 0 5px;

    font-size: 14px;
    font-weight: var(--font-weight-lg);

    color: var(--color-main);

    display: flex;
    align-items: center;

    gap: 5px;

    text-decoration: underline;

    cursor: pointer;

    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.75;
    }

    .arr-icon {
      font-size: 1.2rem;
      flex-shrink: 0;
    }
  }

  /*
   * Belge grid
   */
  .doc-list {
    width: 100%;
    min-width: 0;

    display: grid;

    grid-template-columns:
      repeat(2, minmax(0, 1fr));

    gap: 30px;
  }

  .doc-item {
    width: 100%;
    min-width: 0;

    height: 400px;

    border: 1px solid
      ${({ theme }) => theme.mainTextColor};

    border-radius: 10px;

    overflow: hidden;

    display: flex;
    flex-direction: column;

    background-color: ${({ theme }) =>
      theme.mainBgColor || "transparent"};
  }

  /*
   * Belge başlığı
   */
  .doc-item-top {
    width: 100%;

    min-height: 50px;
    height: 50px;

    flex-shrink: 0;

    border-bottom: 1px solid
      ${({ theme }) => theme.mainBorderColor};

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 7px 15px;

    font-size: var(--font-size-md);
    font-weight: var(--font-weight-lg);

    text-align: center;

    p {
      width: 100%;

      margin: 0;
      padding: 0;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  /*
   * Preview alanı
   */
  .doc-preview {
    position: relative;

    width: 100%;
    min-width: 0;

    flex: 1;

    height: calc(100% - 50px);

    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  /*
   * Belge yoksa
   */
  .empty-document {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 30px;

    img {
      display: block;

      width: 100%;
      height: 100%;

      max-width: 220px;
      max-height: 220px;

      object-fit: contain;

      pointer-events: none;
      user-select: none;
    }
  }

  /*
   * Resim preview
   */
  .image-preview {
    position: relative;

    width: 100%;
    height: 100%;

    overflow: hidden;

    background-color: #111;
  }

  .background-image {
    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;

    opacity: 0.4;

    filter: brightness(40%) blur(2px);

    transform: scale(1.02);

    pointer-events: none;
    user-select: none;
  }

  .foreground-image {
    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    object-fit: contain;

    z-index: 1;

    pointer-events: none;
    user-select: none;
  }

  /*
   * PDF preview
   */
  .pdf-preview {
    width: 100%;
    height: 100%;

    min-width: 0;

    overflow: hidden;

    .rpv-core__viewer {
      width: 100%;
      height: 100%;
    }
  }

  /*
   * Küçük laptop
   */
  @media (max-width: 1200px) {
    .wrapper {
      grid-template-columns:
        minmax(0, 1fr)
        minmax(0, 1fr)
        minmax(160px, 0.6fr);

      gap: 15px;
    }

    .doc-list {
      gap: 20px;
    }

    .doc-item {
      height: 370px;
    }

    .data-item {
      font-size: 13px;
    }
  }

  /*
   * Tablet
   */
  @media (max-width: 900px) {
    border-radius: 15px;

    .wrapper {
      grid-template-columns:
        repeat(2, minmax(0, 1fr));

      gap: 20px;

      padding: 18px;
    }

    /*
     * Belge görüntüleme butonu
     * tablet ekranında yeni satıra geçer.
     */
    .wrapper .column-item:last-child {
      grid-column: 1 / -1;
    }

    .show-doc-Btn {
      font-size: 13px;
    }

    .doc-container {
      padding: 18px;
    }

    .doc-list {
      grid-template-columns:
        repeat(2, minmax(0, 1fr));

      gap: 15px;
    }

    .doc-item {
      height: 340px;
    }

    .doc-item-top {
      height: 48px;
      min-height: 48px;

      padding: 5px 10px;

      font-size: 14px;
    }

    .doc-preview {
      height: calc(100% - 48px);
    }
  }

  /*
   * Mobil
   */
  @media (max-width: 700px) {
    border-radius: 12px;

    .wrapper {
      display: flex;
      flex-direction: column !important;

      align-items: stretch;

      gap: 18px;

      padding: 15px;
    }

    .column-item {
      width: 100%;

      gap: 8px;
    }

    .data-item {
      font-size: 13px;

      flex-wrap: wrap;
    }

    .data-item .key {
      width: auto;
    }

    .show-doc-Btn {
      margin-top: 3px;

      font-size: 13px;
    }

    .doc-container {
      margin-top: 0;

      padding: 15px;
    }

    .doc-container-top {
      margin-bottom: 20px;
    }

    .doc-container-top-title {
      font-size: 16px;
    }

    .doc-container-top-hide-btn {
      font-size: 13px;
    }

    /*
     * Mobilde belgeler tek kolon.
     */
    .doc-list {
      grid-template-columns: 1fr;

      gap: 15px;
    }

    .doc-item {
      height: 420px;
    }

    .doc-item-top {
      height: auto;
      min-height: 50px;

      padding: 8px 10px;

      p {
        white-space: normal;

        overflow: visible;

        text-overflow: unset;

        line-height: 1.3;
      }
    }

    .doc-preview {
      height: auto;

      min-height: 350px;
    }
  }

  /*
   * Küçük telefon
   */
  @media (max-width: 480px) {
    .wrapper {
      padding: 12px;
    }

    .column-item {
      gap: 7px;
    }

    .data-item {
      /*
       * Küçük ekranda key ve value
       * alt alta gelsin.
       */
      flex-direction: column;

      gap: 2px;

      font-size: 13px;
    }

    .data-item .key {
      font-size: 12px;
    }

    .data-item .value {
      font-size: 13px;
    }

    .doc-container {
      padding: 12px;
    }

    .doc-container-top {
      align-items: flex-start;

      gap: 10px;
    }

    .doc-container-top-title {
      font-size: 15px;
    }

    .doc-container-top-hide-btn {
      font-size: 12px;
    }

    .doc-list {
      gap: 12px;
    }

    .doc-item {
      height: 370px;

      border-radius: 8px;
    }

    .doc-item-top {
      min-height: 48px;

      font-size: 13px;

      padding: 7px 8px;
    }

    .doc-preview {
      min-height: 310px;
    }

    .empty-document {
      padding: 30px;

      img {
        max-width: 160px;
        max-height: 160px;
      }
    }
  }

  /*
   * Çok küçük telefon
   */
  @media (max-width: 360px) {
    .wrapper {
      padding: 10px;
    }

    .doc-container {
      padding: 10px;
    }

    .doc-container-top {
      flex-direction: column;

      align-items: flex-start;

      padding-bottom: 5px;
    }

    .doc-item {
      height: 330px;
    }

    .doc-preview {
      min-height: 270px;
    }

    .doc-item-top {
      font-size: 12px;
    }
  }
`;

const RegularVehicleItem = ({
  item,
  openedVehicleDocs,
  setOpenedVehicleDocs,
}) => {

    
  /*
   * Burada state'e ihtiyacımız yok.
   * Component tamamen read-only.
   */
  const fileList = [
    {
      loadedBefore: item?.ruhsatPhoto || null,
      fileTypeName: "Ruhsat",
      staticValue: "ruhsat",
    },
    {
      loadedBefore: item?.tasitKartiPhoto || null,
      fileTypeName: "Taşıt Kartı",
      staticValue: "TasitKartiPhoto",
    },
    {
      loadedBefore: item?.sasePhoto || null,
      fileTypeName: "Şase",
      staticValue: "SasePhoto",
    },
    {
      loadedBefore:
        item?.trafikSigortaPolicePhoto || null,
      fileTypeName: "Trafik Sigorta Poliçesi",
      staticValue: "TrafikSigortaPolicePohoto",
    },
    {
      loadedBefore:
        item?.yukSigortaPolicePhoto || null,
      fileTypeName: "Yük Sigorta Poliçesi",
      staticValue: "YukSigortaPolicePhoto",
    },
    {
      loadedBefore:
        item?.aracFotoOndenSuruculu || null,
      fileTypeName: "Araç Foto Önden Sürücülü",
      staticValue: "AracFotoOndenSuruculu",
    },
    {
      loadedBefore: item?.photo1 || null,
      fileTypeName: "Araç Foto Önden",
      staticValue: "Photo1",
    },
    {
      loadedBefore: item?.photo2 || null,
      fileTypeName: "Araç Foto Yandan",
      staticValue: "Photo2",
    },
    {
      loadedBefore: item?.photo3 || null,
      fileTypeName: "Araç Foto Arkadan",
      staticValue: "Photo3",
    },
  ];

  /*
   * Backend'den MIME type gelmediği için
   * PDF olup olmadığını uzantıdan kontrol ediyoruz.
   */
  const isPdfFile = (filePath) => {
    if (!filePath) {
      return false;
    }

    const cleanPath = filePath
      .split("?")[0]
      .split("#")[0]
      .toLowerCase();

    return cleanPath.endsWith(".pdf");
  };

  /*
   * Dosya tam URL olarak geliyorsa direkt kullan.
   *
   * Sadece path olarak geliyorsa
   * API image URI ile birleştir.
   */
  const getPreviewUrl = (filePath) => {
    if (!filePath) {
      return null;
    }

    if (
      filePath.startsWith("http://") ||
      filePath.startsWith("https://") ||
      filePath.startsWith("blob:")
    ) {
      return filePath;
    }

    return `${process.env.REACT_APP_API_IMG_URI}${filePath}`;
  };

  return (
    <Container>
      {/* Araç bilgileri */}
      <div className="wrapper">
        <div className="column-item">
          <div className="data-item">
            <div className="key">Plaka:</div>

            <div className="value">
              {item?.plate || "---"}
            </div>
          </div>

          <div className="data-item">
            <div className="key">
              Araç Tipi:
            </div>

            <div className="value">
              {item?.vehicleType === 0
                ? "Çekici"
                : item?.vehicleType === 1
                ? "Römork"
                : "---"}
            </div>
          </div>

          <div className="data-item">
            <div className="key">
              Araç Türü:
            </div>

            <div className="value">
              {item?.truckType || "---"}
              {item?.caseType
                ? ` - ${item.caseType}`
                : ""}
            </div>
          </div>
        </div>

        <div className="column-item">
          <div className="data-item">
            <div className="key">
              Trafik Sigortası Geçerlilik Tarihi:
            </div>

            <div className="value">
              {item?.trafikSigortasıGecerlilikTarihi ||
                "---"}
            </div>
          </div>

          <div className="data-item">
            <div className="key">
              Muayene Geçerlilik Tarihi:
            </div>

            <div className="value">
              {item?.muayeneGecerlilikTarihi ||
                "---"}
            </div>
          </div>

          <div className="data-item">
            <div className="key">
              Kasko Geçerlilik Tarihi:
            </div>

            <div className="value">
              {item?.kaskoGecerlilikTarihi ||
                "---"}
            </div>
          </div>
        </div>

        {openedVehicleDocs?.id !== item?.id && (
          <div className="column-item">
            <button
              type="button"
              className="show-doc-Btn"
              onClick={() =>
                setOpenedVehicleDocs(item)
              }
            >
              Araç Belgelerini Görüntüle

              <PiArrowBendRightDown className="arr-icon" />
            </button>
          </div>
        )}
      </div>

      {/* Belgeler */}
      {openedVehicleDocs?.id === item?.id && (
        <div className="doc-container">
          <div className="doc-container-top">
            <div className="doc-container-top-title">
              Araç Belgeleri
            </div>

            <button
              type="button"
              className="doc-container-top-hide-btn"
              onClick={() =>
                setOpenedVehicleDocs(null)
              }
            >
              Belgeleri Gizle

              <PiArrowBendRightUp className="arr-icon" />
            </button>
          </div>

          <div className="doc-list">
            {fileList.map((fileItem) => {
              const previewSrc = getPreviewUrl(
                fileItem.loadedBefore
              );

              const isPdf = isPdfFile(
                fileItem.loadedBefore
              );

              return (
                <div
                  className="doc-item"
                  key={fileItem.staticValue}
                >
                  <div className="doc-item-top">
                    {fileItem.loadedBefore ? (
                      <p>
                        {fileItem.fileTypeName}
                      </p>
                    ) : (
                      <p>
                        Belge Bulunamadı - (
                        {fileItem.fileTypeName})
                      </p>
                    )}
                  </div>

                  <div className="doc-preview">
                    {!previewSrc ? (
                      /*
                       * Belge yüklenmemişse
                       * soru işareti göster.
                       */
                      <div className="empty-document">
                        <img
                          src={questionMark}
                          alt={`${fileItem.fileTypeName} bulunamadı`}
                        />
                      </div>
                    ) : isPdf ? (
                      /*
                       * PDF sadece görüntülenir.
                       * Upload/dropzone işlemi yok.
                       */
                      <div className="pdf-preview">
                        <Worker
                          workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.js`}
                        >
                          <Viewer
                            fileUrl={previewSrc}
                          />
                        </Worker>
                      </div>
                    ) : (
                      /*
                       * Resim sadece görüntülenir.
                       */
                      <div className="image-preview">
                        {/* Arka plan */}
                        <img
                          src={previewSrc}
                          alt=""
                          className="background-image"
                        />

                        {/* Asıl belge */}
                        <img
                          src={previewSrc}
                          alt={
                            fileItem.fileTypeName
                          }
                          className="foreground-image"
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Container>
  );
};

export default RegularVehicleItem;